[
    {
        "title":"CHDI Foundation",
        "description":"CHDI Foundation is a privately-funded, nonprofit biomedical research organization devoted to a single disease – Huntington's disease (HD). Our mission is to develop therapeutics that will provide meaningful clinical benefit to patients as quickly as possible.",
        "image":"assets/static-data/images/chdi.png"
    },
    {
        "title":"NINDS",
        "description":"The National Institute of Neurological Disorders and Stroke (NINDS) is part of the National Institutes of Health (NIH). NINDS seeks fundamental knowledge about the brain and nervous system and uses that knowledge to reduce the burden of neurological disease.",
        "image":"assets/static-data/images/ninds.svg"
    }
]